// The initial RA setup comes back as registered_agent_service from the API.
// change_of_registered_agent covers subsequent transfers. Both represent an
// active registered agent relationship and are treated as equivalent.
export const RA_TASK_TYPES = ['registered_agent_service', 'change_of_registered_agent'];
